import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Store } from '@ngrx/store';
import * as fromAccountStore from '@appStore/account';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private oidcSecurityService: OidcSecurityService;
 
  constructor(private injector: Injector) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let requestToForward = request;

    if (this.oidcSecurityService === undefined) {
      this.oidcSecurityService = this.injector.get(OidcSecurityService);
    }

    if (this.oidcSecurityService !== undefined ) {
      // Version 14 angular-auth-oidc-client


      this.oidcSecurityService.isAuthenticated$
        .pipe(
          filter(authResult => !!authResult && !!authResult.allConfigsAuthenticated && authResult.allConfigsAuthenticated.length > 0),
          map(authResult => authResult.allConfigsAuthenticated.find(cfg => cfg.isAuthenticated)),
          take(1)
        ).subscribe(authConfig => {
          this.oidcSecurityService.getAccessToken(authConfig.configId).subscribe(token => {
            if (token) {
              const tokenValue = 'Bearer ' + token;
              requestToForward = request.clone({ setHeaders: { Authorization: tokenValue } });
          }
          });
        });
      }
        /*
      //TODO: Check correct configuration
      const configs = this.oidcSecurityService.getConfigurations();
      if (configs && configs.length > 0) {
        let configId = configs[0].configId;

        this.oidcSecurityService.getAccessToken(configId).subscribe((token) => {
          if (token) {
              const tokenValue = 'Bearer ' + token;
              requestToForward = request.clone({ setHeaders: { Authorization: tokenValue } });
          }
        });
      }
    } else {
      console.log('OidcSecurityService undefined: NO auth header!');
    }
      */

    return next.handle(requestToForward);
  }
}

/*
CODE BEFORE implementing angular-auth-oidc-client


import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { OidcSecurityService, OidcSecurityValidation } from '@core/auth/angular-auth-oidc-client';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private oidcSecurityService: OidcSecurityService;
  private oidcSecurityValidation: OidcSecurityValidation;

  constructor(private injector: Injector) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let requestToForward = request;

    if (this.oidcSecurityService === undefined) {
      this.oidcSecurityService = this.injector.get(OidcSecurityService);
    }
    if (this.oidcSecurityValidation === undefined) {
      this.oidcSecurityValidation = this.injector.get(OidcSecurityValidation);
    }

    if (this.oidcSecurityService !== undefined) {
      const token = this.oidcSecurityService.getToken();

      if (token !== '') {
        const hasExpired = this.oidcSecurityValidation.isTokenExpired(token);
        if (hasExpired) {
          return throwError({ status: 403, message: 'Session timed out' });
        }
        const tokenValue = 'Bearer ' + token;
        requestToForward = request.clone({ setHeaders: { Authorization: tokenValue } });
      }
    } else {
      console.log('OidcSecurityService undefined: NO auth header added!');
    }

    return next.handle(requestToForward);
  }
}
*/